import { render, staticRenderFns } from "./deckVideoList.vue?vue&type=template&id=90c8f33c&scoped=true&"
import script from "./deckVideoList.vue?vue&type=script&lang=js&"
export * from "./deckVideoList.vue?vue&type=script&lang=js&"
import style0 from "./deckVideoList.vue?vue&type=style&index=0&id=90c8f33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c8f33c",
  null
  
)

export default component.exports